import { StatusCardMobile } from "./StatusCardMobile";
export default StatusCardMobile;
